import { css } from '@emotion/react';
import { isolateComponent, withModifier, labelStyles, } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon';
import { Animation, Colors } from '../../../theme';
const borderWidth = 2;
const Styles = labelStyles('BooleanInput', {
    root: () => [
        css({
            position: 'relative',
            display: 'inline-block',
        }),
    ],
    inner: (props) => [
        css({
            display: 'block',
            position: 'relative',
            zIndex: 1,
            border: `${borderWidth}px solid ${Colors.neutral600}`,
            backgroundColor: 'transparent',
            cursor: 'pointer',
            transition: `all ${Animation.transitionDuration} ease-in-out`,
        }),
        props.type === 'checkbox' && [
            withModifier('checkbox', css({
                width: 18,
                height: 18,
                borderRadius: 3,
                color: Colors.neutral100,
            })),
            props.checked &&
                withModifier('checked', css({
                    backgroundColor: Colors.blue,
                    borderColor: 'transparent',
                })),
            props.isErrored &&
                withModifier('errored', css({
                    backgroundColor: props.checked ? Colors.error : 'transparent',
                    borderColor: Colors.error,
                })),
            props.disabled &&
                withModifier('disabled', css({
                    backgroundColor: props.checked ? Colors.neutral500 : 'transparent',
                    borderColor: Colors.neutral500,
                    cursor: 'not-allowed',
                })),
        ],
        props.type === 'radio' && [
            withModifier('radio', css({
                color: 'transparent',
                width: 20,
                height: 20,
                borderRadius: 20,
            })),
            props.checked &&
                withModifier('checked', css({
                    borderColor: Colors.blue,
                    color: Colors.blue,
                })),
            props.isErrored &&
                withModifier('errored', css({
                    borderColor: Colors.error,
                    color: Colors.error,
                })),
            props.disabled &&
                withModifier('disabled', css({
                    borderColor: Colors.neutral500,
                    color: Colors.neutral500,
                    cursor: 'not-allowed',
                })),
        ],
    ],
    layer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: -borderWidth,
        left: -borderWidth,
        width: `calc(100% + ${2 * borderWidth}px)`,
        height: `calc(100% + ${2 * borderWidth}px)`,
    }),
});
export const BooleanInput = ({ type, ariaLabel = undefined, checked = false, disabled = undefined, id = undefined, isErrored = undefined, isRequired = undefined, name = undefined, onChange = () => { }, tabIndex = 0, value = undefined, }) => {
    const props = {
        type,
        ariaLabel,
        checked,
        disabled,
        id,
        isErrored,
        isRequired,
        name,
        onChange,
        tabIndex,
        value,
    };
    return (isolateComponent("span", { css: Styles.root() },
        isolateComponent("span", { css: Styles.inner(props) },
            isolateComponent("input", { "aria-label": ariaLabel, checked: checked, css: Styles.layer, disabled: disabled, id: id, name: name, onChange: onChange, required: isRequired, tabIndex: tabIndex, type: type, value: value }),
            checked && (isolateComponent("span", { css: Styles.layer },
                isolateComponent(Icon, { isBlock: true, name: {
                        checkbox: 'formCheck',
                        radio: 'formRadioDot',
                    }[type], size: 18 }))))));
};
//# sourceMappingURL=BooleanInput.js.map
// @zapier/design-system@6.27.0 (617a97f69)
